import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: "active",
  mode: "history",
});

router.beforeEach((to, from, next) => {
  const userType = localStorage.getItem("userType");

  if (
    to.meta.allowedUserTypes &&
    !to.meta.allowedUserTypes.includes(userType)
  ) {
    return next("*");
  }

  next();
});

export default router;
